import React, { useState } from 'react';
import CapIcon from '../../CapIcon';
import { clsPrefix, RULE } from './constants';
import CapRow from '../../CapRow';
import { Tooltip } from '../UtilComponents/Tooltip';

const renderLikeDislikeIcons = (isLike, onLike, isDislike, onDislike) => (
  <>
    {isLike ? (
      <CapIcon
        size="s"
        type="filled-like"
        style={{ marginRight: '0.715rem' }}
        data-testid="filled-like-button"
      />
    ) : (
      <CapIcon
        data-selected={isLike}
        onClick={onLike}
        size="s"
        type="like"
        style={{ marginRight: '0.715rem' }}
        data-testid="like-button"
      />
    )}
    {isDislike ? (
      <CapIcon
        size="s"
        type="filled-disLike"
        style={{ marginRight: '0.715rem' }}
        data-testid="filled-dislike-button"
      />
    ) : (
      <CapIcon
        data-selected={isDislike}
        onClick={onDislike}
        size="s"
        type="disLike"
        style={{ marginRight: '0.715rem' }}
        data-testid="dislike-button"
      />
    )}
  </>
);

export const MetaBlock = ({
  content,
  currentTab,
  likeRule,
  likeSummarize,
  likeResp,
  dislikeResp,
}) => {
  const [showCopied, setShowCopied] = useState(false); 

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setShowCopied(true);
    } catch (err) {
      console.error(err);
    }
  };

  const isRuleTab = currentTab === RULE;
  const isLike = isRuleTab ? likeRule === 1 : likeSummarize === 1;
  const isDislike = isRuleTab ? likeRule === -1 : likeSummarize === -1;

  return (
    <div className={`${clsPrefix}-meta-data`}>
      <CapRow type="flex" align="middle">
        <Tooltip title={
          showCopied ? (
            <div className={`${clsPrefix}-tooltip-copied-size`}>
              <CapIcon
                type="check-filled"
                size="s"
                style={{ marginRight: '4px' }}
                data-testid="copied"
              />
              <span>Copied</span>
            </div>
          ) : (
            <div className={`${clsPrefix}-tooltip-size`}>
              Copy
            </div>
          )
        }>
          <CapIcon
            type="copy"
            size="s"
            className={`${clsPrefix}-refresh-data`}
            onClick={handleCopyClick}
            data-testid="copy-button"
          />
        </Tooltip>
      </CapRow>
      <CapRow>
        {renderLikeDislikeIcons(isLike, likeResp, isDislike, dislikeResp)}
      </CapRow>
    </div>
  );
};
